"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../..");

var _style = _interopRequireDefault(require("./style"));

var _helpers = require("./helpers");

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

// eslint-disable-next-line complexity
var Content = function Content(_ref) {
  var children = _ref.children,
      open = _ref.open,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$positionHorizont = _ref.positionHorizontal,
      positionHorizontal = _ref$positionHorizont === void 0 ? 'middle' : _ref$positionHorizont,
      _ref$positionVertical = _ref.positionVertical,
      positionVertical = _ref$positionVertical === void 0 ? 'center' : _ref$positionVertical,
      positions = _ref.positions,
      arrowOffset = _ref.arrowOffset,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      setContent = _ref.setContent,
      className = _ref.className,
      constraintToWindow = _ref.constraintToWindow,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "open", "placement", "positionHorizontal", "positionVertical", "positions", "arrowOffset", "disabled", "setContent", "className", "constraintToWindow"]);
  var container = (0, _react.useRef)(null);
  var theme = (0, _ThemeProvider.useTheme)();
  var styles = (0, _helpers.calculatePlacement)({
    placement: placement,
    positions: positions,
    arrowOffset: arrowOffset,
    positionHorizontal: positionHorizontal,
    positionVertical: positionVertical,
    open: open,
    constraintToWindow: constraintToWindow
  });
  var classes = useStyles({
    theme: theme,
    props: styles
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: container,
    className: classes.Content
  }, /*#__PURE__*/_react["default"].createElement(_.Portal, {
    containerEl: container === null || container === void 0 ? void 0 : container.current
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.Box, disabled && 'disabled', className && className),
    ref: function ref(_ref2) {
      return setContent && setContent(_ref2);
    }
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.Arrow, styles.placement === 'top' && classes.Top, styles.placement === 'left' && classes.Left, styles.placement === 'bottom' && classes.Bottom, styles.placement === 'right' && classes.Right)
  }), children)));
};

Content.displayName = 'ContentBox.Content';
var _default = Content;
exports["default"] = _default;
//# sourceMappingURL=Content.js.map